import Icon from '../../components/Icon.vue'

Icon.register({"brands/mix":{"width":448,"height":512,"paths":[{"d":"M0 64V412.9C0 469.1 88 471 88 412.9V174.3C95.9 121.4 176 123.9 176 180.8V356.1C176 414 272 414.1 272 356.1V240C277.3 185.3 360 187.5 360 244.3V268.1C360 328 448 324.7 448 268.1V64H0z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/mix.js
// module id = Dtlf
// module chunks = 0